/* Taux BCE (frankfurter.dev) — généré par promo-cart/fx_update.py, cron quotidien. Ne pas éditer à la main. */
window.AP_FX={"base":"EUR","date":"2026-11-03","rates":{"AUD":1.6007,"CAD":1.5623,"CHF":0.9166,"GBP":0.8336,"NZD":1.9876,"USD":1.1179}};
